import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './reducers';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import GamePlay from './routers/GamePlay';
import Home from './routers/Home';
import NotFound from './routers/NotFound';
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-5FHSKSH'
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router basename={"/puzzle-fruit"}>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Home />} />
            <Route path='game' element={<GamePlay />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
